export default {"src":"/_next/static/media/Group-25488-1.7cd5d699.svg","height":364,"width":470};